
function initCourseFilter() {
    const dropdown = document.querySelector('.city-filter-js');
    if (!dropdown) return;

    const courseSections = document.querySelectorAll('.course-section');
    if (!courseSections.length) return;

    dropdown.addEventListener('change', function () {
        const selectedCity = (dropdown.value || '').toLowerCase().trim();

        courseSections.forEach(section => {
            const courseRows = section.querySelectorAll('.course-section__line-wrapper');
            if (!courseRows.length) {
                section.style.display = 'none';
                return;
            }

            let hasVisibleCourse = false;

            courseRows.forEach(row => {
                const city = (row.dataset.city || '').toLowerCase().trim();
                const match = !selectedCity || city === selectedCity;

                row.style.display = match ? '' : 'none';
                if (match) hasVisibleCourse = true;
            });

            section.style.display = hasVisibleCourse ? '' : 'none';
        });
    });
}

export default initCourseFilter;
